import { useMutation } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ampli } from '../../../../ampli';
import { patchPokeRating } from '../../../../api/user/mutations/patchPokeRating';

export const usePatchPokeRatingMutation = () => {
  const location = useLocation();

  return useMutation(patchPokeRating, {
    onError: (error: Error) =>
      ampli.에러발생({
        '에러 내용': error.toString(),
        '에러 종류': '피드백 평점 등록 실패',
        '에러가 발생한 URL': location.pathname,
      }),
  });
};
